@if (isVisible()) {
  <aside
    class="w-full bg-amber-2 border-b border-amber-6 px-4 py-3 sm:px-6 sm:py-3.5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-2xs shrink-0 z-20 sticky top-0"
    role="alert"
    aria-live="polite"
  >
    <div class="flex items-center gap-3 min-w-0">
      <div
        class="w-9 h-9 rounded-xl bg-amber-3 border border-amber-5 text-amber-11 flex items-center justify-center shrink-0 shadow-2xs"
      >
        <mat-icon class="!w-5 !h-5 !text-xl">warning_amber</mat-icon>
      </div>
      <div class="min-w-0 space-y-0.5">
        <h4 class="font-bold text-xs sm:text-sm text-amber-12 tracking-tight">
          {{ hasBeenSubscribed() ? 'Abonnement inactif' : 'Abonnement requis' }}
        </h4>
        <p class="text-xs text-amber-11 leading-relaxed">
          @if (hasBeenSubscribed()) {
            Vous conservez l'accès complet à vos mandats en cours et à vos discussions. Pour postuler à de
            nouvelles opportunités de vente, réactivez votre abonnement.
          } @else {
            Pour postuler aux opportunités de vente et accéder à l'ensemble des mandats de votre secteur,
            découvrez nos formules d'abonnement.
          }
        </p>
      </div>
    </div>

    <div class="shrink-0 self-stretch sm:self-auto flex items-center justify-end">
      <a mat-flat-button routerLink="/subscriptions" class="primary font-bold text-xs !h-9 !px-4 shadow-xs">
        {{ hasBeenSubscribed() ? 'Gérer mon abonnement' : 'Découvrir les abonnements' }}
      </a>
    </div>
  </aside>
}
